import { FC, useMemo } from 'react';

import { Formik, type FormikHelpers } from 'formik';
import useModal from 'ui/partials/Modal/useModal';
import {
  LEAD_ONLY_FORM,
  LEAD_ONLY_SCHEMA,
} from 'modules/account/contact/forms/schema';

import { useGetCompanyContactDetails } from '../hooks';
import LeadOnlyForm from '../forms/LeadOnlyForm';
import { useUpdateLeadOnly } from '../hooks/useUpdateLead';

interface PROPS {
  id: string;
}

const UpdateCompanyLeadModal: FC<PROPS> = ({ id }) => {
  const { hideModal } = useModal();
  const { mutate: updateCompanyLeads } = useUpdateLeadOnly(id);
  const { data: companyContactDetails } = useGetCompanyContactDetails(
    id as string,
    {
      include: ['leads', 'tag'],
    },
  );

  const onSubmit = (
    values: LEAD_ONLY_FORM,
    { setSubmitting, resetForm }: FormikHelpers<LEAD_ONLY_FORM>,
  ) => {
    updateCompanyLeads(values as { leadId: string[] }, {
      onSuccess: () => {
        hideModal();
        resetForm();
      },
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  const initialValues = useMemo(
    () => ({
      leadId: companyContactDetails?.leads?.map(({ _id }: any) => _id) ?? [],
    }),
    [companyContactDetails],
  );

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit as any}
      validationSchema={LEAD_ONLY_SCHEMA}
    >
      {() => <LeadOnlyForm />}
    </Formik>
  );
};

export default UpdateCompanyLeadModal;
